import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReviewsProps, SortType } from "./reviews.types";
import { sortReviews } from "./reviews.utils";

export const useLogicReviews = ({ reviews, source, name }: ReviewsProps) => {
  const { t } = useTranslation();
  const [reviewsState, setReviewsState] = useState(reviews);
  const [sortType, setSortType] = useState(SortType.DESC);

  const handleSort = (type: SortType) => {
    setSortType(type);
    setReviewsState(sortReviews(reviews, type));
  };

  useEffect(() => {
    setReviewsState(sortReviews(reviews, SortType.DESC));
  }, [reviews]);

  return {
    t,
    reviewsState,
    sortType,

    handleSort,
  };
};
